module.exports = __webpack_public_path__ + "static/media/express.021976e0.png";